/* DO NOT EDIT! This file is auto-generated by graphql-code-generator - see `codegen.yml` */
import * as Types from './types';

import gql from 'graphql-tag';
import * as Urql from '../../abstractions/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type GetCompanyQueryVariables = Types.Exact<{
  query: Types.Scalars['JSON'];
}>;


export type GetCompanyQuery = { __typename?: 'Query', company: { __typename?: 'Company', ref?: string | null, id: number, name?: string | null, address?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, country?: string | null, owner?: boolean | null, active: boolean } };

export type GetCompaniesForListQueryVariables = Types.Exact<{
  query?: Types.InputMaybe<Types.Scalars['JSON']>;
  sort?: Types.InputMaybe<Types.Scalars['JSON']>;
  limit?: Types.InputMaybe<Types.Scalars['Int']>;
  skip?: Types.InputMaybe<Types.Scalars['Int']>;
}>;


export type GetCompaniesForListQuery = { __typename?: 'Query', companies: { __typename?: 'CompanyListResponse', data: Array<{ __typename?: 'Company', id: number, name?: string | null, country?: string | null, active: boolean }>, pageData?: { __typename?: 'PageData', count: number, limit: number } | null } };

export type SaveCompanyMutationVariables = Types.Exact<{
  company: Types.CompanyInput;
}>;


export type SaveCompanyMutation = { __typename?: 'Mutation', saveCompany: { __typename?: 'Company', ref?: string | null, id: number, name?: string | null, address?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, country?: string | null, owner?: boolean | null, active: boolean } };

export type CompanyFieldsFragment = { __typename?: 'Company', ref?: string | null, id: number, name?: string | null, address?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, country?: string | null, owner?: boolean | null, active: boolean };

export type GetCompaniesForDropdownQueryVariables = Types.Exact<{
  query?: Types.InputMaybe<Types.Scalars['JSON']>;
  sort?: Types.InputMaybe<Types.Scalars['JSON']>;
  limit?: Types.InputMaybe<Types.Scalars['Int']>;
  skip?: Types.InputMaybe<Types.Scalars['Int']>;
}>;


export type GetCompaniesForDropdownQuery = { __typename?: 'Query', companies: { __typename?: 'CompanyListResponse', data: Array<{ __typename?: 'Company', id: number, name?: string | null }>, pageData?: { __typename?: 'PageData', count: number, limit: number } | null } };

export type DropdownDataFragment = { __typename?: 'Company', id: number, name?: string | null };

export type DisableCounterpartyMutationVariables = Types.Exact<{
  companyId: Types.Scalars['Int'];
}>;


export type DisableCounterpartyMutation = { __typename?: 'Mutation', disableCompany: boolean };

export type EnableCounterpartyMutationVariables = Types.Exact<{
  companyId: Types.Scalars['Int'];
}>;


export type EnableCounterpartyMutation = { __typename?: 'Mutation', enableCompany: boolean };

export type ExportChatQueryVariables = Types.Exact<{
  fromDate: Types.Scalars['DateTime'];
  toDate: Types.Scalars['DateTime'];
}>;


export type ExportChatQuery = { __typename?: 'Query', exportChatMessages: string };

export const CompanyFieldsFragmentDoc = gql`
    fragment CompanyFields on Company {
  ref
  id
  name
  address
  city
  state
  postalCode
  country
  owner
  active
}
    `;
export const DropdownDataFragmentDoc = gql`
    fragment DropdownData on Company {
  id
  name
}
    `;
export const GetCompanyDocument = gql`
    query GetCompany($query: JSON!) {
  company(query: $query) {
    ref
    id
    name
    address
    city
    state
    postalCode
    country
    owner
    active
  }
}
    `;

export function useGetCompanyQuery(options: Omit<Urql.UseQueryArgs<GetCompanyQueryVariables>, 'query'>) {
  return Urql.useQuery<GetCompanyQuery>({ query: GetCompanyDocument, ...options });
};
export const GetCompaniesForListDocument = gql`
    query GetCompaniesForList($query: JSON, $sort: JSON, $limit: Int, $skip: Int) {
  companies(query: $query, sort: $sort, limit: $limit, skip: $skip) {
    data {
      id
      name
      country
      active
    }
    pageData {
      count
      limit
    }
  }
}
    `;

export function useGetCompaniesForListQuery(options?: Omit<Urql.UseQueryArgs<GetCompaniesForListQueryVariables>, 'query'>) {
  return Urql.useQuery<GetCompaniesForListQuery>({ query: GetCompaniesForListDocument, ...options });
};
export const SaveCompanyDocument = gql`
    mutation SaveCompany($company: CompanyInput!) {
  saveCompany(company: $company) {
    ...CompanyFields
  }
}
    ${CompanyFieldsFragmentDoc}`;

export function useSaveCompanyMutation() {
  return Urql.useMutation<SaveCompanyMutation, SaveCompanyMutationVariables>(SaveCompanyDocument);
};
export const GetCompaniesForDropdownDocument = gql`
    query GetCompaniesForDropdown($query: JSON, $sort: JSON, $limit: Int, $skip: Int) {
  companies(query: $query, sort: $sort, limit: $limit, skip: $skip) {
    data {
      ...DropdownData
    }
    pageData {
      count
      limit
    }
  }
}
    ${DropdownDataFragmentDoc}`;

export function useGetCompaniesForDropdownQuery(options?: Omit<Urql.UseQueryArgs<GetCompaniesForDropdownQueryVariables>, 'query'>) {
  return Urql.useQuery<GetCompaniesForDropdownQuery>({ query: GetCompaniesForDropdownDocument, ...options });
};
export const DisableCounterpartyDocument = gql`
    mutation DisableCounterparty($companyId: Int!) {
  disableCompany(companyId: $companyId)
}
    `;

export function useDisableCounterpartyMutation() {
  return Urql.useMutation<DisableCounterpartyMutation, DisableCounterpartyMutationVariables>(DisableCounterpartyDocument);
};
export const EnableCounterpartyDocument = gql`
    mutation EnableCounterparty($companyId: Int!) {
  enableCompany(companyId: $companyId)
}
    `;

export function useEnableCounterpartyMutation() {
  return Urql.useMutation<EnableCounterpartyMutation, EnableCounterpartyMutationVariables>(EnableCounterpartyDocument);
};
export const ExportChatDocument = gql`
    query ExportChat($fromDate: DateTime!, $toDate: DateTime!) {
  exportChatMessages(fromDate: $fromDate, toDate: $toDate)
}
    `;

export function useExportChatQuery(options: Omit<Urql.UseQueryArgs<ExportChatQueryVariables>, 'query'>) {
  return Urql.useQuery<ExportChatQuery>({ query: ExportChatDocument, ...options });
};